import * as React from 'react'
import { connect } from 'react-redux'

import { loadingSelector } from 'embed/selectors/loading'
import { MultiProductState } from 'embed/reducers'
import { Product } from 'even-ts-static'

interface OwnProps {
  children: React.ReactNode
  product: Product
}

interface StoreProps {
  isLoading: boolean
}

type Props = OwnProps & StoreProps

const OnceLoaded: React.SFC<Props> = ({ children, isLoading }) => (isLoading ? null : <>{children}</>)

export const mapStateToProps = (state: MultiProductState, { product }: OwnProps) => ({
  isLoading: loadingSelector(state, product),
})

export default connect<StoreProps, {}, OwnProps>(mapStateToProps)(OnceLoaded)
